import { serviceTypes, modulesConfig } from '../config';

export const cacheVersion = '0';
export const moduleId = 'MyBus';
export const modulePath = serviceTypes[modulesConfig.MyBus.serviceType].path;

export const pagePaths = {
  Module: modulePath,
};
